import React, {useState, useRef, useEffect, useContext} from 'react'
import t from '../../helpers/I18n'
import { AppDataContext } from '../../contexts/app-data'

const Footer = () => {
  const lang = localStorage.getItem('language')
    const {state, dispatch} = useContext(AppDataContext)

const ref = useRef(null)
 useEffect(() => {
 reziseHandle()
 }, [])
  
  const reziseHandle = () => {
    window.onresize = () => {
          dispatch({
          type: 'SET_FOOTER_HEIGHT',
          value: ref.current.clientHeight
      })
    }
  }
  
  return (
    <footer ref={ref}>
      <a target="_blank" href={lang === "FR" ? "https://www.hellobank.be/fr/pages-legales/disclaimer" : "https://www.hellobank.be/nl/wettelijke-info/disclaimer"} rel="noreferrer">{ t('footer.link1')}</a>
      <a target="_blank" href={lang === "FR" ? "https://www.hellobank.be/fr/pages-legales/vie-privee" : "https://www.hellobank.be/nl/wettelijke-info/privacy"} rel="noreferrer">{ t('footer.link2')}</a>
      {/* <a target="_blank" href={lang === "FR" ? "https://www.hellobank.be/fr/pages-legales/cookies" : "https://www.hellobank.be/nl/wettelijke-info/cookies"} rel="noreferrer">{t('footer.link3')}</a> */}
      <a target="_self" href="javascript:top.PageBus.publish(&#39;cc.policy.popup&#39;);" rel="noreferrer">{t('footer.link3')}</a>
      

      {process.env.REACT_APP_ENV === "qa" && <a target="_blank" href={lang === "FR" ? "https://pro.qahellobank.be/fr/public/documents-legaux-tarifs" : "https://pro.qahellobank.be/nl/public/wettelijke-documenten-tarieven"} rel="noreferrer">{t('footer.link4')}</a> }
      {process.env.REACT_APP_ENV === "prod" && <a target="_blank" href={lang === "FR" ? "https://pro.hellobank.be/fr/public/documents-legaux-tarifs" : "https://pro.hellobank.be/nl/public/wettelijke-documenten-tarieven"} rel="noreferrer">{t('footer.link4')}</a> }
      {process.env.REACT_APP_ENV !== "prod" && process.env.REACT_APP_ENV !== "qa" && <a target="_blank" href={lang === "FR" ? "https://pro.qahellobank.be/fr/public/documents-legaux-tarifs" : "https://pro.qahellobank.be/nl/public/wettelijke-documenten-tarieven"} rel="noreferrer">{t('footer.link4')}</a>}
      
      {/* <a target="_self" href="javascript:top.PageBus.publish(&#39;cc.policy.popup&#39;);"  rel="noreferrer">Cookie</a> */}
      
    </footer>
  )
}

export default Footer
